// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".groupWarin[data-v-008b211c]{background:#ffff80}.layoutTableCard .tableGroup .tableList[data-v-008b211c]{flex-wrap:nowrap}", ""]);
// Exports
module.exports = exports;
